export default __webpack_public_path__ + "static/media/admin.5093d4de.png";